import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {
  #enabled = false;

  set enabled(value: boolean) {
    this.#enabled = value;
  }

  get enabled(): boolean {
    return this.#enabled;
  }
}
